@if (loadingContent) {
<content-loading-list />
}

<div class="card">
  @if (pager.total === 0) {
  <empty-records-component
    [buttonClass]="'btn btn-info fw-bold'"
    [message]="'contact.attendanceList.noAttendances' | translate"
    [icon]="'mdi mdi-alert-circle-outline'"
    [subMessage]="
      'contact.attendanceList.noAttendancesSubMessage' | translate
    "
  />
  }@if(!loadingContent && pager.total > 0) {
  <div class="card-body table-responsive">
    <table class="table table-hover table-centered mb-0">
      <thead>
        <tr>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colChannel' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colProtocol' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colStartDate' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colResponsible' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colDepartment' | translate }}</th>
          <th class="text-primary-emphasis">{{ 'contact.attendanceList.colStatus' | translate }}</th>
          <th class="sr-only"></th>
        </tr>
      </thead>
      <tbody>
        @for (item of pager.list; track item) {
        <tr
          (click)="showDetailsAttendanceHitory(item)"
          class="fs-6"
          style="cursor: pointer"
        >
          <td>
            <span>
              @switch (item.channel?.type) { @case ('CLOUD_API') {
              <div class="position-relative d-inline-block">
                <img
                  src="../../../assets/images/icon-whatsapp.svg"
                  alt="WhatsApp Business"
                  class="img-fluid avatar-sm"
                />
                <span
                  class="badge rounded-circle px-2 py-1 fs-6 position-absolute top-1 start-100 translate-middle"
                  [ngClass]="isHybridChannel(item.channel) ? 'channel-seal--hybrid' : 'text-success'"
                >
                  <i class="mdi mdi-check-decagram"></i>
                </span>
              </div>
              } @case ('INSTAGRAM_API') {
              <img
                src="../../../assets/images/icon-instagram.png"
                alt="Instagram"
                class="img-fluid avatar-sm"
              />
              } @case ('MESSENGER_API') {
              <img
                src="../../../assets/images/icon-messenger.png"
                alt="Messenger"
                class="img-fluid avatar-sm"
              />
              } @case ('RCS_API') {
              <img
                src="../../../assets/images/Google-Messages.png"
                alt="RCS"
                class="img-fluid avatar-sm"
              />
              } @default {
              <img
                src="../../../assets/images/icon-whatsapp.svg"
                [alt]="'contact.attendanceList.whatsappUnofficialAlt' | translate"
                class="img-fluid avatar-sm"
              />
              } }
              {{ $safeNavigationMigration(item.channel?.name) | truncate : 15 }}
            </span>
          </td>
          <td>
            <strong class="text-truncate">{{ item.protocol }}</strong>
          </td>
          <td>
            <span>
              {{
                $safeNavigationMigration(item?.createdAt)
                  | timezoneDate
                    : "DD/MM/YYYY"
                    : getTimezoneCompanyCurrentUser()
              }}</span
            >
          </td>
          <td>
            <span>{{ item?.user?.name }} </span>
          </td>
          <td>
            <span>{{ item?.department?.name }}</span>
          </td>
          <td>
            <span
              class="badge font-12 text-capitalize"
              [ngClass]="{
                'bg-success': item?.status === 'IN_PROGRESS',
                'bg-warning': item?.status === 'PENDING',
                'bg-danger': item?.status === 'OVERTIME',
                'bg-primary': item?.status === 'PAUSED',
                'bg-secondary': item?.status === 'CLOSED'
              }"
              >{{ translateStatus($safeNavigationMigration(item?.status)) }}</span
            >
          </td>

          <td>
            <div class="d-flex justify-content-end">
              <button
                class="btn btn-dropdown-list"
                [matMenuTriggerFor]="menu"
                type="button"
                (click)="$event.stopPropagation()"
                (mousedown)="$event.stopPropagation()"
              >
                <i class="mdi mdi-dots-vertical text-primary-emphasis"></i>
              </button>

              <mat-menu #menu="matMenu">
                @if(showTransferButton(item)) {
                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="
                    openAssignedUserTransferModal(item);
                    $event.stopPropagation()
                  "
                >
                  {{ 'contact.attendanceList.transfer' | translate }}
                </button>
                }

                <button
                  mat-menu-item
                  tabindex="0"
                  (click)="showDetailsAttendanceHitory(item)"
                >
                  {{ 'contact.attendanceList.viewAttendance' | translate }}
                </button>
              </mat-menu>
            </div>
          </td>
        </tr>
        }
      </tbody>
    </table>

    @if (pager.total > pager.perPage) {
    <paginator [pager]="pager" (onPager)="loadPage($event)" />
    }
  </div>
  }
</div>
